import * as C from '../common/constants';
import { useSelector, useDispatch } from 'react-redux';
import { OrbitControls } from '@react-three/drei';

const Orbit = () => {
  const isModelRotating = useSelector(
    (state: any) => state.app[C.SET_ROTATION]
  );

  return (
    <OrbitControls
      target={[0, -1.3, 0]}
      autoRotate={isModelRotating}
      autoRotateSpeed={1.2}
      // panSpeed={0.2}
      rotateSpeed={0.25}
      // dampingFactor={0.1}
      enableDamping={false}
      enablePan={false}
      // enableDamping={false}
      // maxDistance={10}
      // minDistance={10}
      // minZoom={1}
      // maxZoom={20}
      // minDistance={50}
      // maxAzimuthAngle={Math.PI / 2}
      // minAzimuthAngle={Math.PI / 4}
      minPolarAngle={Math.PI / 2 - 10}
      maxPolarAngle={Math.PI / 2 - 0.3}
      enableZoom={false}
    />
  );
};

export default Orbit;

// maxDistance={15}
// minDistance={5}
// minZoom={1}
// maxZoom={20}
// minDistance={50}
